module.exports = __webpack_public_path__ + "static/media/page_45_right.828ae3e0.png";